"use strict";
'use es6'; // *****PROTECTED*******
// DO NOT USE OUTSIDE OF FILE MANAGER CODE

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileAccessValues = exports.PrivateFileAccess = exports.HiddenInAppFileAccessList = exports.HIDDEN_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE = exports.HIDDEN_IN_APP_PUBLIC_TO_ALL_INDEXABLE = exports.HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE = exports.VISIBLE_IN_APP_PRIVATE_NOT_INDEXABLE = exports.VISIBLE_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE = exports.VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _FileAccessValues;

var VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE = 'VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE';
exports.VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE = VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE;
var VISIBLE_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE = 'VISIBLE_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE';
exports.VISIBLE_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE = VISIBLE_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE;
var VISIBLE_IN_APP_PRIVATE_NOT_INDEXABLE = 'VISIBLE_IN_APP_PRIVATE_NOT_INDEXABLE';
exports.VISIBLE_IN_APP_PRIVATE_NOT_INDEXABLE = VISIBLE_IN_APP_PRIVATE_NOT_INDEXABLE;
var HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE = 'HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE';
exports.HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE = HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE;
var HIDDEN_IN_APP_PUBLIC_TO_ALL_INDEXABLE = 'HIDDEN_IN_APP_PUBLIC_TO_ALL_INDEXABLE';
exports.HIDDEN_IN_APP_PUBLIC_TO_ALL_INDEXABLE = HIDDEN_IN_APP_PUBLIC_TO_ALL_INDEXABLE;
var HIDDEN_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE = 'HIDDEN_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE';
exports.HIDDEN_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE = HIDDEN_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE;
var HiddenInAppFileAccessList = [HIDDEN_IN_APP_PUBLIC_TO_ALL_INDEXABLE, HIDDEN_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE, HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE];
exports.HiddenInAppFileAccessList = HiddenInAppFileAccessList;
var PrivateFileAccess = [VISIBLE_IN_APP_PRIVATE_NOT_INDEXABLE, HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE];
exports.PrivateFileAccess = PrivateFileAccess;
var FileAccessValues = (_FileAccessValues = {}, (0, _defineProperty2.default)(_FileAccessValues, VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE, {
  allowsAnonymousAccess: true,
  isIndexable: true,
  hidden: false
}), (0, _defineProperty2.default)(_FileAccessValues, VISIBLE_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE, {
  allowsAnonymousAccess: true,
  isIndexable: false,
  hidden: false
}), (0, _defineProperty2.default)(_FileAccessValues, VISIBLE_IN_APP_PRIVATE_NOT_INDEXABLE, {
  allowsAnonymousAccess: false,
  isIndexable: false,
  hidden: false
}), (0, _defineProperty2.default)(_FileAccessValues, HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE, {
  allowsAnonymousAccess: false,
  isIndexable: false,
  hidden: true
}), (0, _defineProperty2.default)(_FileAccessValues, HIDDEN_IN_APP_PUBLIC_TO_ALL_INDEXABLE, {
  allowsAnonymousAccess: true,
  isIndexable: true,
  hidden: true
}), (0, _defineProperty2.default)(_FileAccessValues, HIDDEN_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE, {
  allowsAnonymousAccess: true,
  isIndexable: false,
  hidden: true
}), _FileAccessValues);
exports.FileAccessValues = FileAccessValues;